import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SidebarProps } from 'shared/prop-types/ReducerProps';
import SidebarContent from './SidebarContent';
import './Sidebar.scss';

const Sidebar = ({ changeMobileSidebarVisibility, sidebar, menu }) => {
  const sidebarClass = classNames({
    sidebar: true,
    'sidebar--show': sidebar.show,
    'sidebar--collapse': sidebar.collapse,
  });

  return (
    <div className={sidebarClass}>
      <button
        type="button"
        className="sidebar__back"
        onClick={changeMobileSidebarVisibility}
      />
      <div className="sidebar__wrapper sidebar__wrapper--desktop">
        <SidebarContent onClick={() => {}} menu={menu} />
      </div>
      <div className="sidebar__wrapper sidebar__wrapper--mobile">
        <SidebarContent onClick={changeMobileSidebarVisibility} menu={menu} />
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  sidebar: SidebarProps.isRequired,
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
  menu: PropTypes.shape().isRequired,
};

export default Sidebar;
